/**
 * Google Ads conversion helpers for ODSP landing pages.
 *
 * Form submissions and click-to-call use separate conversion actions:
 *   form: AW-301221669/RCIxCKy3k_scEKWO0Y8B
 *   call: AW-301221669/SM9jCO7Q9_8cEKWO0Y8B
 *
 * window.gtag_report_conversion is the official Google click-to-call snippet name.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (root) {
    root.OdspAdsConversions = api;
    root.gtag_report_conversion = function gtag_report_conversion(url) {
      return api.reportCallConversion(root, url);
    };
  }
})(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var FORM_SEND_TO = 'AW-301221669/RCIxCKy3k_scEKWO0Y8B';
  var CALL_SEND_TO = 'AW-301221669/SM9jCO7Q9_8cEKWO0Y8B';
  var GA4_MEASUREMENT_ID = 'G-Q1H0FZQL9H';
  var GA4_FORM_EVENT = 'odsp_form_submitted';
  var CALL_VALUE = 1.0;
  var CALL_CURRENCY = 'CAD';
  var CALL_NAV_FALLBACK_MS = 1500;

  function ensureGtag(win) {
    if (!win) return function () {};
    win.dataLayer = win.dataLayer || [];
    if (typeof win.gtag !== 'function') {
      win.gtag = function () {
        win.dataLayer.push(arguments);
      };
    }
    return win.gtag;
  }

  function reportConversion(win, options) {
    options = options || {};
    var url = options.url;
    var navigated = false;
    var callback = function () {
      if (navigated) return;
      if (typeof url !== 'undefined' && url) {
        navigated = true;
        win.location = url;
      }
    };

    ensureGtag(win);

    var payload = {
      send_to: options.sendTo,
      event_callback: callback
    };

    if (typeof options.value === 'number') {
      payload.value = options.value;
    }
    if (options.currency) {
      payload.currency = options.currency;
    }
    if (options.transaction_id) {
      payload.transaction_id = options.transaction_id;
    }

    win.gtag('event', 'conversion', payload);

    if (url && win.setTimeout) {
      win.setTimeout(callback, CALL_NAV_FALLBACK_MS);
    }

    return false;
  }

  function reportFormConversion(win, extras) {
    extras = extras || {};
    return reportConversion(win, {
      sendTo: FORM_SEND_TO,
      transaction_id: extras.transaction_id
    });
  }

  function reportGa4Event(win, eventName, params) {
    ensureGtag(win);
    var payload = { send_to: GA4_MEASUREMENT_ID };
    if (params) {
      Object.keys(params).forEach(function (key) {
        payload[key] = params[key];
      });
    }
    win.gtag('event', eventName, payload);
    return false;
  }

  function reportGa4FormEvent(win) {
    return reportGa4Event(win, GA4_FORM_EVENT, {
      form_id: 'odsp-registration-form'
    });
  }

  function publishShopify(win, eventName, data) {
    if (
      win.Shopify &&
      win.Shopify.analytics &&
      typeof win.Shopify.analytics.publish === 'function'
    ) {
      win.Shopify.analytics.publish(eventName, data || {});
    }
  }

  /*
   * One Ads conversion via GTM (odsp_form_submitted dataLayer event).
   * Do not also call reportFormConversion here — that duplicates AW-301221669.
   * GA4 form event is sent separately to G-Q1H0FZQL9H.
   */
  function notifyFormSubmitted(win) {
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push({ event: 'odsp_form_submitted' });
    reportGa4FormEvent(win);
    publishShopify(win, 'odsp:form_submitted', {
      form_id: 'odsp-registration-form'
    });
    return false;
  }

  function reportCallConversion(win, url, extras) {
    extras = extras || {};
    return reportConversion(win, {
      sendTo: CALL_SEND_TO,
      url: url,
      value: CALL_VALUE,
      currency: CALL_CURRENCY,
      transaction_id: extras.transaction_id
    });
  }

  function isTelLink(el) {
    if (!el || !el.getAttribute) return false;
    var href = el.getAttribute('href') || '';
    return href.indexOf('tel:') === 0;
  }

  function bindCallButtons(root, win) {
    if (!root || !root.querySelectorAll) return 0;
    var links = root.querySelectorAll('a[href^="tel:"], #odsp-call-button, .odsp-call-button');
    var seen = [];
    var count = 0;

    function attach(link) {
      if (!link || seen.indexOf(link) !== -1) return;
      if (!isTelLink(link) && link.id !== 'odsp-call-button' && !(link.classList && link.classList.contains('odsp-call-button'))) {
        return;
      }
      seen.push(link);
      if (link.getAttribute('data-odsp-call-bound') === 'true') return;
      link.setAttribute('data-odsp-call-bound', 'true');
      if (link.getAttribute('onclick')) return;
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href) return;
        event.preventDefault();
        reportCallConversion(win, href);
      });
      count += 1;
    }

    for (var i = 0; i < links.length; i++) {
      attach(links[i]);
    }
    return count;
  }

  return {
    FORM_SEND_TO: FORM_SEND_TO,
    CALL_SEND_TO: CALL_SEND_TO,
    GA4_MEASUREMENT_ID: GA4_MEASUREMENT_ID,
    GA4_FORM_EVENT: GA4_FORM_EVENT,
    CALL_VALUE: CALL_VALUE,
    CALL_CURRENCY: CALL_CURRENCY,
    ensureGtag: ensureGtag,
    reportConversion: reportConversion,
    reportFormConversion: reportFormConversion,
    reportGa4Event: reportGa4Event,
    reportGa4FormEvent: reportGa4FormEvent,
    notifyFormSubmitted: notifyFormSubmitted,
    reportCallConversion: reportCallConversion,
    bindCallButtons: bindCallButtons
  };
});
